import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-onefield-dialog',
  templateUrl: './onefield-dialog.component.html',
  styleUrls: ['./onefield-dialog.component.scss']
})
export class OneFieldDialogComponent implements OnInit {

  public title = '';
  public fieldName = '';
  public okMsg = 'Ok';
  public cancelMsg = 'Annuler';
  public field = '';

  constructor(private dialogRef: MatDialogRef<OneFieldDialogComponent>, @Inject(MAT_DIALOG_DATA) data) {
    if (typeof data.title !== 'undefined') {
      this.title = data.title;
    }
    if (typeof data.fieldName !== 'undefined') {
      this.fieldName = data.fieldName;
    }
    if (typeof data.okMsg !== 'undefined') {
      this.okMsg = data.okMsg;
    }
    if (typeof data.cancelMsg !== 'undefined') {
      this.cancelMsg = data.cancelMsg;
    }
  }

  ngOnInit(): void {
  }

  public ok(): void {
    this.dialogRef.close(this.field);
  }

  public cancel(): void {
    this.dialogRef.close(false);
  }

}
